// GenericSubmittedApplicationPDF.jsx
import { Document } from "@react-pdf/renderer";
import { removeEmptyObjectValues } from "../../../_src_shared/utils/objects/removeEmptyObjectValues";

import PdfSection from "../pdfBuilder/components/layout/PdfSection";
import PdfPageBranded from "../pdfBuilder/pages/PdfPageBranded";
import PdfGenericDataTable from "./pages/PdfGenericDataTable";
import { convertObjectToReadableEntries } from "../../../_src_shared/utils/objects/convertObjectToReadableEntries";

const GenericSubmittedApplicationPDF = ({
  formData,
  title,
  formatOptions = {},
  sortKeys = true, // Default to true for alphabetical sorting
}) => {
  const convertPdfData = () => {
    // First remove empty values
    let cleanedData = removeEmptyObjectValues({ ...formData });

    // Then apply formatting if options are provided
    if (formatOptions && Object.keys(formatOptions).length > 0) {
      return convertObjectToReadableEntries(cleanedData, {
        ...formatOptions,
        sortKeys,
      });
    }

    // If no format options, still apply sortKeys if needed
    if (sortKeys) {
      return convertObjectToReadableEntries(cleanedData, { sortKeys });
    }

    return cleanedData;
  };

  return (
    <Document>
      <PdfPageBranded
        pageNumber={"1 of 1"}
        pageTitle={title || "Submitted Application"}
        date={new Date().toISOString().split("T")[0]}
      >
        <PdfSection>
          <PdfGenericDataTable data={convertPdfData()} title={title} />
        </PdfSection>
      </PdfPageBranded>
    </Document>
  );
};

export default GenericSubmittedApplicationPDF;
